var MaskCalculator = (function () {
    function MaskCalculator() {
    }
    MaskCalculator.calculateMask = function (maskLength) {
        var error = new Error("Invalid mask length. Mask length must be an integer number between 0 and 32.");
        if ($.isNumeric(maskLength) == false)
            throw error;
        if (parseFloat(maskLength) % 1 !== 0)
            throw error;
        if (length < 0 || length > 32)
            throw error;
        var length = parseInt(maskLength);
        var lengthOfZeros = 32 - length;
        var binaryString = Array(length + 1).join('1') + Array(lengthOfZeros + 1).join('0');
        var firstOctetDec = parseInt(binaryString.slice(0, 8), 2);
        var secondOctetDec = parseInt(binaryString.slice(8, 16), 2);
        var thirdOctetDec = parseInt(binaryString.slice(16, 24), 2);
        var fourthOctetDec = parseInt(binaryString.slice(24), 2);
        return [firstOctetDec, secondOctetDec, thirdOctetDec, fourthOctetDec].join('.');
    };
    MaskCalculator.calculateMaskLength = function (mask) {
        var length = ipaddr.parse(mask).prefixLengthFromSubnetMask();
        if (length == null)
            throw new Error("Invalid subnet mask.");
        return length;
    };
    return MaskCalculator;
}());
//# sourceMappingURL=mask-calculator.js.map